import { useCallback, useMemo, useState } from 'react'
import Dialog from '../Dialog'
import ConfirmContext from './ConfirmContext'

const ConfirmProvider = ({ children }) => {
  const [confirm, setConfirm] = useState(null)
  const [open, setOpen] = useState(false)

  const show = useCallback((confirmOptions) => {
    setConfirm(confirmOptions)
    setOpen(true)
  }, [])

  const onClose = useCallback(
    (action) => {
      setOpen(false)
      confirm?.onClose?.(action)
    },
    [confirm]
  )

  const value = useMemo(() => ({ show }), [show])

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      <Dialog
        {...confirm}
        error
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={onClose}
      />
    </ConfirmContext.Provider>
  )
}

export default ConfirmProvider
